export default "__VITE_ASSET__e572896b__"